import React from 'react';

// Reusable Parallax Shapes Component for all pages
export const ParallaxShapes = ({ scrollY = 0 }) => {
  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 1 }}>
      {/* Large circle top left */}
      <div 
        className="absolute w-[400px] h-[400px] rounded-full bg-[#264F77]/[0.12]"
        style={{ 
          top: '5%', 
          left: '-5%',
          transform: `translateY(${scrollY * 0.1}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {/* Square top right */}
      <div 
        className="absolute w-[250px] h-[250px] bg-[#264F77]/[0.10] rotate-45"
        style={{ 
          top: '15%', 
          right: '-3%',
          transform: `translateY(${scrollY * -0.15}px) rotate(45deg)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {/* Circle middle left */}
      <div 
        className="absolute w-[180px] h-[180px] rounded-full bg-[#264F77]/[0.14]"
        style={{ 
          top: '45%', 
          left: '5%',
          transform: `translateY(${scrollY * 0.12}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {/* Square bottom right */}
      <div 
        className="absolute w-[200px] h-[200px] bg-[#264F77]/[0.10] rotate-12"
        style={{ 
          top: '60%', 
          right: '8%',
          transform: `translateY(${scrollY * -0.08}px) rotate(12deg)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {/* Small circle bottom left */}
      <div 
        className="absolute w-[120px] h-[120px] rounded-full bg-[#264F77]/[0.15]"
        style={{ 
          top: '75%', 
          left: '15%',
          transform: `translateY(${scrollY * 0.05}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {/* Line element */}
      <div 
        className="absolute h-[2px] w-[300px] bg-gradient-to-r from-transparent via-[#264F77]/30 to-transparent"
        style={{ 
          top: '35%', 
          left: '30%',
          transform: `translateX(${scrollY * 0.05}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
    </div>
  );
};
